import TotalBody from '../../pages/total-body/TotalBody'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.TOTAL_BODY, component: TotalBody },
])
